/**
 * The product id that entitles an org to accord, stored in
 * `organizations/{orgId}/product-access/config.enabledProducts`. Written at
 * provisioning time (sales/onboarding flow) — deliberately not part of
 * admin-console's product catalog.
 */
export const ACCORD_PRODUCT_ID = 'accord';

export interface ProductAccessConfig {
  enabledProducts: string[];
  roleProductAccess: Record<string, string[]>;
}
